

// // import React, { useEffect, useState, useMemo } from 'react';
// // import './Management3.css';
// // import axios from 'axios';
// // import Cashbilling from './Cashbilling';
// // import "./Company.css";
// // import "./Style.css";
// // import Settlement from './Settlement';
// // import WalletAdd from './WalletAdd';
// // import { useLoader } from "../../../../context/LoaderProvider.jsx";
// // import { Approval } from '@mui/icons-material';

// // const Management3 = () => {
// //   const [activeTab, setActiveTab] = useState('Overview');
// //   const [vendorId, setVendorId] = useState(null);
// //   const isMobile = useState(window.innerWidth < 768);
// //   const [selectedDate, setSelectedDate] = useState("");
// //   const [allOrders, setAllOrders] = useState([]);
// //   const [filteredData, setFilteredData] = useState([]);
// //   const { showLoader, hideLoader } = useLoader();

// //   // Category filter states
// //   const [categories, setCategories] = useState(["All Categories"]);
// //   const [selectedCategory, setSelectedCategory] = useState("All Categories");
// //   const [dishCategoryMap, setDishCategoryMap] = useState({});
// //   const containerHeight = window.innerWidth < 768
// //     ? '300px'       // Mobile
// //     : window.innerWidth < 850
// //       ? '300px'     // Below 850px
// //       : window.innerWidth < 1400
// //         ? '410px'   // Between 850px and 1399px
// //         : window.innerWidth < 1600
// //           ? '430px' // Between 1400px and 1599px
// //           : '450px'; // Above 1600px

// //   // Helper function to determine if order is completed
// //   const isOrderCompleted = (order) => {
// //     const paymentMethod = order.paymentMethod?.toLowerCase();
// //     const orderStatus = (order.status || '').toUpperCase();
// //     const cashStatus = (order.cashStatus || '').toUpperCase();

// //     // Always exclude cancelled orders
// //     const isCancelled = orderStatus === 'CANCELLED' || cashStatus === 'CANCELLED';
// //     if (isCancelled) {
// //       return false;
// //     }

// //     // For ONLINE payments - payment is already done when order is placed
// //     // So count all online payment orders (except cancelled)
// //     if (paymentMethod === 'online_payment') {
// //       return true; // Online payment already completed
// //     }

// //     // For CASH payments - only count if cash is accepted
// //     if (paymentMethod === 'cash') {
// //       return cashStatus === 'ACCEPT';
// //     }

// //     // For WALLET payments - payment is already done
// //     if (paymentMethod === 'maamaas_wallet' || paymentMethod === 'wallet') {
// //       return true; // Wallet payment already completed
// //     }

// //     // Default: count if not cancelled
// //     return true;
// //   };

// //   // Calculate totals based on filtered data (date-specific)
// //   const totals = useMemo(() => {
// //     let walletIncome = 0, onlineIncome = 0, cashIncome = 0;

// //     filteredData.forEach(order => {
// //       const amount = order.grandTotal || 0;
// //       const method = order.paymentMethod;
// //       const orderStatus = (order.status || '').toUpperCase();

// //       // Skip cancelled orders (will be refunded)
// //       if (orderStatus === 'CANCELLED') {
// //         return; // Skip this order
// //       }

// //       // Count based on payment method
// //       if (method === "Online_Payment") {
// //         onlineIncome += amount;
// //       } else if (method === "Cash") {
// //         cashIncome += amount;
// //       } else if (method === "Maamaas_Wallet" || method?.toLowerCase() === "wallet") {
// //         walletIncome += amount;
// //       }
// //     });

// //     const totalIncome = walletIncome + onlineIncome + cashIncome;

// //     return {
// //       walletIncome,
// //       onlineIncome,
// //       cashIncome,
// //       totalIncome
// //     };
// //   }, [filteredData]);

// //   // Date navigation functions
// //   const goToPreviousDay = () => {
// //     if (selectedDate) {
// //       const currentDate = new Date(selectedDate);
// //       currentDate.setDate(currentDate.getDate() - 1);
// //       setSelectedDate(currentDate.toISOString().split('T')[0]);
// //     } else {
// //       // If no date selected, start from yesterday
// //       const yesterday = new Date();
// //       yesterday.setDate(yesterday.getDate() - 1);
// //       setSelectedDate(yesterday.toISOString().split('T')[0]);
// //     }
// //   };

// //   const goToNextDay = () => {
// //     if (selectedDate) {
// //       const currentDate = new Date(selectedDate);
// //       currentDate.setDate(currentDate.getDate() + 1);

// //       // Don't allow future dates
// //       const today = new Date();
// //       today.setHours(0, 0, 0, 0);
// //       if (currentDate <= today) {
// //         setSelectedDate(currentDate.toISOString().split('T')[0]);
// //       }
// //     } else {
// //       // If no date selected, start from today
// //       const today = new Date();
// //       setSelectedDate(today.toISOString().split('T')[0]);
// //     }
// //   };

// //   const goToToday = () => {
// //     const today = new Date();
// //     setSelectedDate(today.toISOString().split('T')[0]);
// //   };

// //   // Fetch orders
// //   useEffect(() => {
// //     if (!vendorId) return;
// //     const fetchOrders = async () => {
// //       const token = localStorage.getItem("authToken");
// //       if (!token) {
// //         console.error("Authorization token is missing");
// //         return;
// //       }

// //       try {
// //         showLoader();
// //         const res = await axios.get(
// //           `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //           { headers: { Authorization: `Bearer ${token}` } }
// //         );

// //         const orders = res.data || [];
// //         setAllOrders(orders);
// //         setFilteredData(orders);

// //         // Debug: Check order dates
// //         //////console.log("Orders fetched:", orders.length);
// //         orders.forEach(order => {
// //           //////console.log("Order date:", order.orderDateAndTime, "Formatted:", new Date(order.orderDateAndTime).toISOString().split('T')[0]);
// //         });

// //       } catch (err) {
// //         console.error("Error fetching orders:", err);
// //       } finally {
// //         hideLoader();
// //       }
// //     };

// //     fetchOrders();
// //   }, [vendorId]);

// //   // Fetch categories and create dish-to-category mapping
// //   useEffect(() => {
// //     if (!vendorId) return;

// //     const fetchCategoriesAndMapping = async () => {
// //       const token = localStorage.getItem("authToken");
// //       if (!token) {
// //         console.error("Authorization token is missing");
// //         return;
// //       }

// //       try {
// //         showLoader();
// //         const res = await axios.get(
// //           `https://backend.maamaas.com/food/api/dishes/vendor/${vendorId}`,
// //           { headers: { Authorization: `Bearer ${token}` } }
// //         );

// //         const dishes = res.data || [];

// //         // Create mapping of dishName to category name
// //         const categoryMap = {};
// //         const categoriesSet = new Set();

// //         dishes.forEach(dish => {
// //           if (dish.parentId === 0) {
// //             // This is a category
// //             categoriesSet.add(dish.dishName);
// //           } else {
// //             // This is a dish - find its category
// //             const category = dishes.find(cat => cat.dishId === dish.parentId);
// //             if (category) {
// //               categoryMap[dish.dishName] = category.dishName;
// //             }
// //           }
// //         });

// //         //////console.log("Category mapping created:", categoryMap);
// //         //////console.log("Categories found:", Array.from(categoriesSet));

// //         setDishCategoryMap(categoryMap);
// //         setCategories(["All Categories", ...Array.from(categoriesSet).sort()]);

// //       } catch (err) {
// //         console.error("Error fetching categories:", err);
// //       } finally {
// //         hideLoader();
// //       }
// //     };

// //     fetchCategoriesAndMapping();
// //   }, [vendorId]);

// //   // Filter orders based on selected date AND selected category - FIXED
// //   useEffect(() => {
// //     if (!selectedDate && selectedCategory === "All Categories") {
// //       setFilteredData(allOrders);
// //       return;
// //     }

// //     const filtered = allOrders.filter((order) => {
// //       // Date filter - FIXED
// //       let dateMatch = true;
// //       if (selectedDate) {
// //         try {
// //           const orderDate = new Date(order.orderDateAndTime);
// //           const orderDateStr = orderDate.toISOString().split('T')[0];
// //           dateMatch = orderDateStr === selectedDate;
// //         } catch (error) {
// //           console.error("Error parsing date:", order.orderDateAndTime);
// //           dateMatch = false;
// //         }
// //       }

// //       // Category filter - FIXED
// //       let categoryMatch = true;
// //       if (selectedCategory !== "All Categories") {
// //         categoryMatch = order.order && order.order.some((item) => {
// //           const dishCategory = dishCategoryMap[item.dishName];
// //           if (!dishCategory) return false;
// //           return dishCategory.toLowerCase().includes(selectedCategory.toLowerCase());
// //         });
// //       }

// //       return dateMatch && categoryMatch;
// //     });



// //     setFilteredData(filtered);
// //   }, [selectedDate, selectedCategory, allOrders, dishCategoryMap]);

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     if (storedVendorId) {
// //       setVendorId(storedVendorId);
// //     }
// //   }, []);

// //   // Other helper functions for data display
// //   const getUserName = (order) => {
// //     return order.userName || "Guest";
// //   };

// //   const getTransactionId = (order) => {
// //     const paymentMethod = order.paymentMethod?.toLowerCase();
// //     if (paymentMethod === "cash") {
// //       return "-";
// //     }
// //     return order.transactionId || "-";
// //   };

// //   const getOrderStatus = (order) => {
// //     const status = order.status || order.cashStatus || order.paymentStatus || "Pending";
// //     return status.charAt(0) + status.slice(1).toLowerCase().replace(/_/g, ' ');
// //   };

// //   const getPaymentMethod = (order) => {
// //     const method = order.paymentMethod;
// //     if (!method) return "Unknown";

// //     switch (method.toLowerCase()) {
// //       case "online_payment":
// //         return "Online Payment";
// //       case "maamaas_wallet":
// //         return "Wallet";
// //       case "cash":
// //         return "Cash";
// //       default:
// //         return method;
// //     }
// //   };

// //   const exportToCSV = () => {
// //     if (filteredData.length === 0) {
// //       alert("No data to export!");
// //       return;
// //     }

// //     const headers = [

// //       "Order ID",
// //       "Date",
// //       "Category",
// //       "Type",
// //       "Name",
// //       "Payment",
// //       "Order Status",
// //       "Amount",
// //     ];

// //     const rows = filteredData.map((item, index) => [
// //       index + 1,
// //       item.orderId,
// //       new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
// //       item.appType || "-",
// //       item.orderType || item.orderService || "-",
// //       getUserName(item),
// //       getPaymentMethod(item),
// //       getOrderStatus(item),
// //       Math.round(item.grandTotal || 0),
// //     ]);

// //     const csvContent =
// //       [headers, ...rows]
// //         .map((row) => row.map((v) => `"${v}"`).join(","))
// //         .join("\n");

// //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
// //     const url = URL.createObjectURL(blob);
// //     const link = document.createElement("a");
// //     link.href = url;
// //     link.setAttribute("download", `orders_${selectedDate || new Date().toISOString().split("T")[0]}.csv`);
// //     document.body.appendChild(link);
// //     link.click();
// //     document.body.removeChild(link);
// //   };

// //   const clearDateFilter = () => {
// //     setSelectedDate("");
// //     setSelectedCategory("All Categories");
// //   };

// //   const clearCategoryFilter = () => {
// //     setSelectedCategory("All Categories");
// //   };

// //   // Format date for display
// //   const formatDisplayDate = (dateString) => {
// //     if (!dateString) return '';
// //     const date = new Date(dateString);
// //     return date.toLocaleDateString('en-US', {
// //       weekday: 'short',
// //       year: 'numeric',
// //       month: 'short',
// //       day: 'numeric'
// //     });
// //   };
// //   const isPaymentCompleted = (order) => {
// //     const orderStatus = (order.status || '').toUpperCase();

// //     // ONLY exclude CANCELLED orders (for refund cases)
// //     // All other orders should be counted regardless of order status
// //     return orderStatus !== 'CANCELLED';
// //   };

// //   // Overview Tab Content
// //   const tabContent = {
// //     Overview: (
// //       <div style={{ marginTop: "20px" }}>
// //         <div className="status-overview">
// //           {[
// //             { title: "Total Income", value: totals.totalIncome, color: "#2c6eaa" },
// //             { title: "Wallet Income", value: totals.walletIncome, color: "#4ecdc4" },
// //             { title: "Online Income", value: totals.onlineIncome, color: "#45b7d1" },
// //             { title: "Cash Income", value: totals.cashIncome, color: "#96ceb4" },
// //           ].map((card, idx) => (
// //             <div key={idx} style={{ background: card.color, color: "#fff", padding: "5px" }} className="status-card dine-in">
// //               <h4 style={{ display: 'flex', justifyContent: "center", fontSize: "16px", margin: "10px 0" }}>
// //                 {card.title}
// //               </h4>
// //               <p style={{
// //                 fontWeight: "bold",
// //                 display: 'flex',
// //                 justifyContent: "center",
// //                 fontSize: "18px",
// //                 margin: "10px 0"
// //               }}>
// //                 ₹{card.value.toLocaleString("en-IN")}
// //               </p>
// //             </div>
// //           ))}
// //         </div>

// //         <div className="payment-history-container">
// //           <style>
// //             {`
// // .payment-history-container {
// //   box-sizing: border-box;
// //   width: 100%;
// //   max-width: 100%;
// // }

// // .filters {
// //   margin-bottom: 20px;
// //   width: 100%;
// // }

// // .filters-single-line {
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   gap: 15px;
// //   flex-wrap: nowrap;
// //   width: 100%;
// // }

// // .date-navigation {
// //   display: flex;
// //   align-items: center;
// //   gap: 8px;
// //   flex: 1;
// // }

// // .date-navigation button {
// //   padding: 8px 12px;
// //   background-color: #b15dc6;
// //   color: white;
// //   border: none;
// //   border-radius: 5px;
// //   cursor: pointer;
// //   font-size: 14px;
// //   font-weight: bold;
// //   min-width: 40px;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   white-space: nowrap;
// // }

// // .date-navigation button:disabled {
// //   background-color: #ccc;
// //   cursor: not-allowed;
// // }

// // .today-button {
// //   background-color: #28a745 !important;
// //   padding: 6px 12px !important;
// //   font-size: 12px !important;
// // }

// // .clear-button {
// //   background-color: #ff6b6b !important;
// //   color: white !important;
// //   padding: 6px 12px !important;
// //   font-size: 12px !important;
// //   transition: opacity 0.2s ease;
// // }

// // .calendar-container {
// //   position: relative;
// //   display: inline-block;
// // }

// // .calendar-button {
// //   padding: 8px 16px;
// //   background-color: #b15cd6;
// //   color: #fff;
// //   border: none;
// //   border-radius: 5px;
// //   cursor: pointer;
// //   font-weight: bold;
// //   display: flex;
// //   align-items: center;
// //   gap: 8px;
// //   font-size: 14px;
// //   min-width: 110px;
// //   justify-content: center;
// // }

// // .category-search {
// //   flex: 0 0 auto;
// // }

// // .category-search input {
// //   padding: 8px 12px;
// //   border: 1px solid #ddd;
// //   border-radius: 5px;
// //   background-color: white;
// //   font-size: 14px;
// //   min-width: 180px;
// //   outline: none;
// // }

// // .category-search input:focus {
// //   border-color: #b15cd6;
// //   box-shadow: 0 0 0 2px rgba(177, 92, 214, 0.2);
// // }

// // .export-button {
// //   padding: 10px 20px;
// //   background-color: #b15cd6;
// //   color: #fff;
// //   border: none;
// //   border-radius: 5px;
// //   font-weight: bold;
// //   cursor: pointer;
// //   white-space: nowrap;
// //   flex: 0 0 auto;
// // }

// // .table-wrapper {
// //   width: 100%;
// //   overflow-x: auto;
// //   -webkit-overflow-scrolling: touch;
// //   background: #fff;
// //   border-radius: 8px;
// // }

// // table {
// //   width: 100%;
// //   min-width: 850px;
// //   border-collapse: collapse;
// // }

// // th, td {
// //   border: 1px solid #ddd;
// //   padding: 10px;
// //   font-size: 13px;
// //   text-align: left;
// //   white-space: nowrap;
// // }

// // th {
// //   background-color: #b15dc6;
// //   font-weight: bold;
// //   font-size: 14px;
// //   color: white;
// // }

// // tr:nth-child(even) {
// //   background-color: #ffffff;
// // }

// // tr:nth-child(odd) {
// //   background-color: #f9f9f9;
// // }

// // @media screen and (max-width: 768px) {
// //   .payment-history-container {
// //     max-width: 100%;
// //     padding: 0px;
// //   }

// //   .filters-single-line {
// //     flex-direction: column;
// //     align-items: stretch;
// //     gap: 10px;
// //   }

// //   .date-navigation {
// //     justify-content: center;
// //     width: 100%;
// //     flex-wrap: wrap;
// //   }

// //   .category-search {
// //     width: 100%;
// //     display: flex;
// //     justify-content: center;
// //   }

// //   .category-search input {
// //     width: 100%;
// //     max-width: 200px;
// //   }

// //   .export-button {
// //     width: 100%;
// //     max-width: 200px;
// //     align-self: center;
// //   }

// //   table {
// //     min-width: 600px;
// //   }
// // }

// // .my-container {
// //   overflow-y: scroll;
// //   -ms-overflow-style: none; 
// //   scrollbar-width: none;
// // }

// // .my-container::-webkit-scrollbar {
// //   display: none;
// // }

// // .tab-content {
// //   width: 100%;
// //   max-width: 840px;
// // }

// // @media (min-width: 999px) {
// //   .export-button {
// //     margin-left: 0 !important;
// //     margin-top: 0 !important;
// //   }
// // }
// // `}
// //           </style>

// //           <div className="filters"
// //             style={{ overflow: "auto", scrollbarWidth: "none", overflowY: "hidden" }}>
// //             <div className="filters-single-line">
// //               {/* Date Navigation */}
// //               <div className="date-navigation">
// //                 <button onClick={goToPreviousDay} title="Previous Day">←</button>

// //                 <div className="calendar-container">
// //                   <button
// //                     className="calendar-button"
// //                     onClick={() => document.getElementById("hiddenDateInput").showPicker()}
// //                     style={{ width: "12rem" }}
// //                   >
// //                     📅 {selectedDate ? formatDisplayDate(selectedDate) : "Select Date"}
// //                   </button>
// //                   <input
// //                     id="hiddenDateInput"
// //                     type="date"
// //                     max={new Date().toISOString().split("T")[0]}
// //                     value={selectedDate}
// //                     onChange={(e) => setSelectedDate(e.target.value)}
// //                     style={{
// //                       position: "absolute",
// //                       opacity: 0,
// //                       pointerEvents: "none",
// //                       width: "0px",
// //                       height: "0px",
// //                       left: "-30px",
// //                     }}
// //                   />
// //                 </div>

// //                 <button
// //                   onClick={goToNextDay}
// //                   disabled={selectedDate === new Date().toISOString().split('T')[0]}
// //                   title={selectedDate === new Date().toISOString().split('T')[0] ? "Can't go beyond today" : "Next Day"}
// //                 >
// //                   →
// //                 </button>

// //                 <button onClick={goToToday} className="today-button" title="Go to Today">
// //                   Today
// //                 </button>

// //                 <button
// //                   onClick={clearDateFilter}
// //                   className="clear-button"
// //                   style={{
// //                     visibility: selectedDate ? 'visible' : 'hidden',
// //                     opacity: selectedDate ? 1 : 0,
// //                   }}
// //                 >
// //                   Show All
// //                 </button>
// //               </div>

// //               {/* Category Search Bar */}
// //               <div className="category-search">
// //                 <input
// //                   type="text"
// //                   placeholder="Search by category..."
// //                   value={selectedCategory === "All Categories" ? "" : selectedCategory}
// //                   onChange={(e) => {
// //                     const value = e.target.value.trim();
// //                     if (value === "") {
// //                       setSelectedCategory("All Categories");
// //                     } else {
// //                       setSelectedCategory(value);
// //                     }
// //                   }}
// //                   style={{
// //                     padding: "8px 12px",
// //                     border: "1px solid #ddd",
// //                     borderRadius: "5px",
// //                     fontSize: "14px",
// //                     minWidth: "180px",
// //                     outline: "none"
// //                   }}
// //                 />
// //               </div>

// //               {/* Export Button */}
// //               <button className="export-button" onClick={exportToCSV}>
// //                 Export
// //               </button>
// //             </div>
// //           </div>

// //           <div className="table-wrapper"
// //             style={{ marginTop: "-30px", }}>
// //             <table>
// //               <thead>
// //                 <tr>
// //                   <th style={{textAlign:"center"}}>OrderID</th>
// //                   <th style={{textAlign:"center"}}>Date & Time</th>
// //                   <th style={{textAlign:"center"}}>Name</th>
// //                   <th style={{textAlign:"center"}}>Payment</th>
// //                   <th style={{textAlign:"center"}}>Transaction ID</th>
// //                   <th style={{textAlign:"center"}}>Status</th>
// //                   <th style={{textAlign:"center"}}>Amount</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {filteredData.length === 0 ? (
// //                   <tr>
// //                     <td colSpan="8" style={{ textAlign: "center" }}>
// //                       {selectedDate || selectedCategory !== "All Categories"
// //                         ? `No orders found for ${selectedDate ? formatDisplayDate(selectedDate) : ''}${selectedDate && selectedCategory !== "All Categories" ? ' and ' : ''}${selectedCategory !== "All Categories" ? `category: ${selectedCategory}` : ''}`
// //                         : 'No orders available'}
// //                     </td>
// //                   </tr>
// //                 ) : (
// //                   filteredData.map((item, index) => (
// //                     <tr key={index}>
// //                       <td style={{textAlign:"center"}} >{item.orderId}</td>
// //                       <td style={{textAlign:"center"}}>{new Date(item.orderDateAndTime).toLocaleString()}</td>
// //                       <td style={{textAlign:"center"}}>{getUserName(item)}</td>
// //                       <td style={{textAlign:"center"}}>{getPaymentMethod(item)}</td>
// //                       <td style={{textAlign:"center"}}>{getTransactionId(item)}</td>
// //                       <td style={{textAlign:"center"}}>{getOrderStatus(item)}</td>
// //                       <td style={{textAlign:"center"}}>₹{Math.round(item.grandTotal || 0)}</td>
// //                     </tr>
// //                   ))
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>
// //     ),
// //     "Cash Billing": <Cashbilling />,
// //     Settlement: <Settlement />,
// //     WalletApproval: <WalletAdd />,
// //   };

// //   return (
// //     <div className="container-fluid">
// //       <div className="row">
// //         <div className="col-lg-12 col-md-12 col-sm-12">
// //           <div className="left-column">
// //             <div className="tabs-wrapperpayment">
// //               <div style={{ textAlign: 'center' }}>
// //                 {Object.keys(tabContent).map((label) => (
// //                   <button
// //                     key={label}
// //                     style={{
// //                       backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
// //                       border: 'none',
// //                       borderRadius: '10px',
// //                       width: window.innerWidth < 1100 ? '110px' : '120px',
// //                       height: '40px',
// //                       color: 'black',
// //                       fontWeight: 'bold',
// //                       cursor: 'pointer',
// //                       transition: 'background-color 0.3s ease',
// //                       margin: '10px'
// //                     }}
// //                     className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
// //                     onClick={() => setActiveTab(label)}
// //                   >
// //                     {label}
// //                   </button>
// //                 ))}
// //               </div>
// //               <div
// //                 className="tab-content my-container"
// //                 style={{
// //                   overflow: 'auto',
// //                   height: window.innerHeight <= 550 ? "60vh" : window.innerHeight <= 600 ? "65vh" : window.innerHeight > 600 ? "70vh" : containerHeight,
// //                   scrollbarWidth: "none",
// //                   msOverflowStyle: "none",
// //                   maxWidth: '1100px',
// //                 }}
// //               >
// //                 {tabContent[activeTab]}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Management3;





// import './Management3.css';
// import axios from 'axios';
// import Cashbilling from './Cashbilling';
// import "./Company.css";
// import "./Style.css";
// import Settlement from './Settlement';
// import WalletAdd from './WalletAdd';
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import { Approval } from '@mui/icons-material';
// import React, { useEffect, useState, useMemo, useRef } from 'react';

// const Management3 = () => {
//   const [activeTab, setActiveTab] = useState('Overview');
//   const [vendorId, setVendorId] = useState(null);
//   const isMobile = window.innerWidth < 768;
//   const [selectedDate, setSelectedDate] = useState("");
//   const [allOrders, setAllOrders] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const { showLoader, hideLoader } = useLoader();
//   const [showCustomPopup, setShowCustomPopup] = useState(false);
//   const [tempStartDate, setTempStartDate] = useState("");
//   const [tempEndDate, setTempEndDate] = useState("");
//   // Inside your component:
//   const popupRef = useRef(null);
//   // Add useEffect to handle outside clicks
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (popupRef.current && !popupRef.current.contains(event.target)) {
//         setShowCustomPopup(false);
//       }
//     };

//     if (showCustomPopup) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showCustomPopup]);

//   // Date filter states
//   const [dateFilterType, setDateFilterType] = useState('today'); // today, monthly, quarterly, yearly, custom
//   const [customStartDate, setCustomStartDate] = useState("");
//   const [customEndDate, setCustomEndDate] = useState("");

//   // Category filter states
//   const [categories, setCategories] = useState(["All Categories"]);
//   const [selectedCategory, setSelectedCategory] = useState("All Categories");
//   const [dishCategoryMap, setDishCategoryMap] = useState({});
//   const containerHeight = window.innerWidth < 768
//     ? '300px'       // Mobile
//     : window.innerWidth < 850
//       ? '300px'     // Below 850px
//       : window.innerWidth < 1400
//         ? '410px'   // Between 850px and 1399px
//         : window.innerWidth < 1600
//           ? '430px' // Between 1400px and 1599px
//           : '450px'; // Above 1600px

//   // Helper function to determine if order is completed
//   const isOrderCompleted = (order) => {
//     const paymentMethod = order.paymentMethod?.toLowerCase();
//     const orderStatus = (order.status || '').toUpperCase();
//     const cashStatus = (order.cashStatus || '').toUpperCase();

//     // Always exclude cancelled orders
//     const isCancelled = orderStatus === 'CANCELLED' || cashStatus === 'CANCELLED';
//     if (isCancelled) {
//       return false;
//     }

//     // For ONLINE payments - payment is already done when order is placed
//     // So count all online payment orders (except cancelled)
//     if (paymentMethod === 'online_payment') {
//       return true; // Online payment already completed
//     }

//     // For CASH payments - only count if cash is accepted
//     if (paymentMethod === 'cash') {
//       return cashStatus === 'ACCEPT';
//     }

//     // For WALLET payments - payment is already done
//     if (paymentMethod === 'maamaas_wallet' || paymentMethod === 'wallet') {
//       return true; // Wallet payment already completed
//     }

//     // Default: count if not cancelled
//     return true;
//   };

//   // Calculate totals based on filtered data
//   const totals = useMemo(() => {
//     let walletIncome = 0, onlineIncome = 0, cashIncome = 0;

//     filteredData.forEach(order => {
//       const amount = order.grandTotal || 0;
//       const method = order.paymentMethod;
//       const orderStatus = (order.status || '').toUpperCase();

//       // Skip cancelled orders (will be refunded)
//       if (orderStatus === 'CANCELLED') {
//         return; // Skip this order
//       }

//       // Count based on payment method
//       if (method === "Online_Payment") {
//         onlineIncome += amount;
//       } else if (method === "Cash") {
//         cashIncome += amount;
//       } else if (method === "Maamaas_Wallet" || method?.toLowerCase() === "wallet") {
//         walletIncome += amount;
//       }
//     });

//     const totalIncome = walletIncome + onlineIncome + cashIncome;

//     return {
//       walletIncome,
//       onlineIncome,
//       cashIncome,
//       totalIncome
//     };
//   }, [filteredData]);


//   const applyDateFilter = (type) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     const endDate = new Date();
//     endDate.setHours(23, 59, 59, 999); // End of today

//     let startDate = new Date();

//     switch (type) {
//       case 'today':
//         // Today only - from start of today to end of today
//         startDate = new Date(today);
//         setSelectedDate(today.toISOString().split('T')[0]);
//         setCustomStartDate(startDate.toISOString().split('T')[0]);
//         setCustomEndDate(endDate.toISOString().split('T')[0]);
//         break;

//       case 'weekly':
//         // Last 7 days (including today)
//         startDate = new Date(today);
//         startDate.setDate(today.getDate() - 6);
//         startDate.setHours(0, 0, 0, 0);
//         setSelectedDate("");
//         setCustomStartDate(startDate.toISOString().split('T')[0]);
//         setCustomEndDate(endDate.toISOString().split('T')[0]);
//         break;

//       case 'monthly':
//         // This month
//         startDate = new Date(today.getFullYear(), today.getMonth(), 1);
//         startDate.setHours(0, 0, 0, 0);
//         setSelectedDate("");
//         setCustomStartDate(startDate.toISOString().split('T')[0]);
//         setCustomEndDate(endDate.toISOString().split('T')[0]);
//         break;

//       case 'quarterly':
//         // Last 3 months
//         startDate = new Date(today);
//         startDate.setMonth(today.getMonth() - 2);
//         startDate.setDate(1);
//         startDate.setHours(0, 0, 0, 0);
//         setSelectedDate("");
//         setCustomStartDate(startDate.toISOString().split('T')[0]);
//         setCustomEndDate(endDate.toISOString().split('T')[0]);
//         break;

//       case 'yearly':
//         // This year
//         startDate = new Date(today.getFullYear(), 0, 1);
//         startDate.setHours(0, 0, 0, 0);
//         setSelectedDate("");
//         setCustomStartDate(startDate.toISOString().split('T')[0]);
//         setCustomEndDate(endDate.toISOString().split('T')[0]);
//         break;

//       case 'custom':
//         // Custom date - will be handled separately
//         setSelectedDate("");
//         break;
//     }

//     setDateFilterType(type);
//   };

//   // Clear all filters
//   // Clear all filters
//   const clearAllFilters = () => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     setSelectedDate(today.toISOString().split('T')[0]);
//     setCustomStartDate("");
//     setCustomEndDate("");
//     setDateFilterType('today');
//     setSelectedCategory("All Categories");
//   };

//   // Fetch orders
//   useEffect(() => {
//     if (!vendorId) return;
//     const fetchOrders = async () => {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.error("Authorization token is missing");
//         return;
//       }

//       try {
//         showLoader();
//         const res = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const orders = res.data || [];
//         setAllOrders(orders);
//         setFilteredData(orders);

//       } catch (err) {
//         console.error("Error fetching orders:", err);
//       } finally {
//         hideLoader();
//       }
//     };

//     fetchOrders();
//   }, [vendorId]);

//   // Fetch categories and create dish-to-category mapping
//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchCategoriesAndMapping = async () => {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.error("Authorization token is missing");
//         return;
//       }

//       try {
//         showLoader();
//         const res = await axios.get(
//           `https://backend.maamaas.com/food/api/dishes/vendor/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const dishes = res.data || [];

//         // Create mapping of dishName to category name
//         const categoryMap = {};
//         const categoriesSet = new Set();

//         dishes.forEach(dish => {
//           if (dish.parentId === 0) {
//             // This is a category
//             categoriesSet.add(dish.dishName);
//           } else {
//             // This is a dish - find its category
//             const category = dishes.find(cat => cat.dishId === dish.parentId);
//             if (category) {
//               categoryMap[dish.dishName] = category.dishName;
//             }
//           }
//         });

//         setDishCategoryMap(categoryMap);
//         setCategories(["All Categories", ...Array.from(categoriesSet).sort()]);

//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       } finally {
//         hideLoader();
//       }
//     };

//     fetchCategoriesAndMapping();
//   }, [vendorId]);


//   useEffect(() => {
//     if (!allOrders.length) {
//       setFilteredData([]);
//       return;
//     }

//     const filtered = allOrders.filter((order) => {
//       // Parse order date
//       let orderDate;
//       try {
//         orderDate = new Date(order.orderDateAndTime);
//         if (isNaN(orderDate.getTime())) {
//           return false; // Invalid date
//         }
//       } catch (error) {
//         console.error("Error parsing date:", order.orderDateAndTime);
//         return false;
//       }

//       const orderDateStr = orderDate.toISOString().split('T')[0];
//       const orderDateTime = orderDate.getTime();

//       // Date filter logic
//       let dateMatch = false;

//       // Create date objects for comparison
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);

//       const orderDateOnly = new Date(orderDate);
//       orderDateOnly.setHours(0, 0, 0, 0);

//       if (dateFilterType === 'today') {
//         // Check if order date is today
//         dateMatch = orderDateOnly.getTime() === today.getTime();
//       }
//       else if (customStartDate && customEndDate) {
//         // For date ranges
//         const start = new Date(customStartDate);
//         start.setHours(0, 0, 0, 0);

//         const end = new Date(customEndDate);
//         end.setHours(23, 59, 59, 999);

//         dateMatch = orderDate >= start && orderDate <= end;
//       }

//       // Category filter
//       let categoryMatch = true;
//       if (selectedCategory !== "All Categories") {
//         categoryMatch = order.order && order.order.some((item) => {
//           const dishCategory = dishCategoryMap[item.dishName];
//           if (!dishCategory) return false;
//           return dishCategory.toLowerCase().includes(selectedCategory.toLowerCase());
//         });
//       }

//       return dateMatch && categoryMatch;
//     });

//     setFilteredData(filtered);
//   }, [selectedDate, customStartDate, customEndDate, selectedCategory, allOrders, dishCategoryMap, dateFilterType]);



//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//     }
//   }, []);

//   // Apply today filter by default on component mount
//   useEffect(() => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     const endDate = new Date();
//     endDate.setHours(23, 59, 59, 999);

//     setSelectedDate(today.toISOString().split('T')[0]);
//     setCustomStartDate(today.toISOString().split('T')[0]);
//     setCustomEndDate(endDate.toISOString().split('T')[0]);
//     setTempStartDate(today.toISOString().split('T')[0]); // Add this
//     setTempEndDate(endDate.toISOString().split('T')[0]); // Add this
//     setDateFilterType('today');
//   }, []);

//   // Helper functions for data display
//   const getUserName = (order) => {
//     return order.userName || "Guest";
//   };

//   const getTransactionId = (order) => {
//     const paymentMethod = order.paymentMethod?.toLowerCase();
//     if (paymentMethod === "cash") {
//       return "-";
//     }
//     return order.transactionId || "-";
//   };

//   const getOrderStatus = (order) => {
//     const status = order.status || order.cashStatus || order.paymentStatus || "Pending";
//     return status.charAt(0) + status.slice(1).toLowerCase().replace(/_/g, ' ');
//   };

//   const getPaymentMethod = (order) => {
//     const method = order.paymentMethod;
//     if (!method) return "Unknown";

//     switch (method.toLowerCase()) {
//       case "online_payment":
//         return "Online";
//       case "maamaas_wallet":
//         return "Wallet";
//       case "cash":
//         return "Cash";
//       default:
//         return method;
//     }
//   };

//   const exportToCSV = () => {
//     if (filteredData.length === 0) {
//       alert("No data to export!");
//       return;
//     }

//     const headers = [
//       "Order ID",
//       "Date",
//       "Category",
//       "Type",
//       "Name",
//       "Payment",
//       "Order Status",
//       "Amount",
//     ];

//     const rows = filteredData.map((item, index) => [
//       index + 1,
//       item.orderId,
//       new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
//       item.appType || "-",
//       item.orderType || item.orderService || "-",
//       getUserName(item),
//       getPaymentMethod(item),
//       getOrderStatus(item),
//       Math.round(item.grandTotal || 0),
//     ]);

//     const csvContent =
//       [headers, ...rows]
//         .map((row) => row.map((v) => `"${v}"`).join(","))
//         .join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `orders_${selectedDate || new Date().toISOString().split("T")[0]}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Format date for display
//   const formatDisplayDate = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       weekday: 'short',
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   // Get display text for current date filter
//   // Get display text for current date filter
//   const getDateFilterDisplay = () => {
//     switch (dateFilterType) {
//       case 'today':
//         return formatDisplayDate(selectedDate) || 'Today';
//       case 'weekly':
//         return `Last 7 Days (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
//       case 'monthly':
//         return `This Month (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
//       case 'quarterly':
//         return `Last 3 Months (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
//       case 'yearly':
//         return `This Year (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
//       case 'custom':
//         if (customStartDate && customEndDate) {
//           return `Custom (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
//         }
//         return 'Select Custom Dates';
//       default:
//         return 'Today';
//     }
//   };

//   // Overview Tab Content
//   const tabContent = {
//     Overview: (
//       <div style={{ marginTop: "0px" }}>
//         {/* Date Filter Buttons */}
//         <div style={{
//           background: 'white',
//           borderRadius: '12px',
//           padding: '5px',
//           marginBottom: '10px',
//           border: '0px solid #E5E7EB'
//         }}>
//           {/* Main container for date filter buttons */}
//           <div style={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '16px'
//           }}>
//             {/* Date filter buttons - responsive layout */}

//             {/* For large screens: All buttons in one line */}
//             <div style={{
//               display: window.innerWidth < 1024 ? 'none' : 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               gap: '12px'
//             }}>
//               <div style={{
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 gap: '10px',
//                 flex: 1
//               }}>
//                 {['yearly', 'quarterly', 'monthly', 'weekly', 'today', 'custom'].map((type) => (
//                   <button
//                     key={type}
//                     onClick={() => {
//                       if (type === 'custom') {
//                         setShowCustomPopup(true);
//                         setTempStartDate(customStartDate || "");
//                         setTempEndDate(customEndDate || "");
//                       } else {
//                         applyDateFilter(type);
//                       }
//                     }}
//                     style={{
//                       padding: '10px 10px',
//                       background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
//                       color: dateFilterType === type ? 'white' : '#374151',
//                       border: 'none',
//                       borderRadius: '8px',
//                       fontSize: '14px',
//                       fontWeight: '500',
//                       cursor: 'pointer',
//                       transition: 'all 0.2s',
//                       textTransform: 'capitalize',
//                       minWidth: '80px',
//                       whiteSpace: 'nowrap'
//                     }}
//                     onMouseEnter={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#e5e7eb';
//                       }
//                     }}
//                     onMouseLeave={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#f3f4f6';
//                       }
//                     }}
//                   >
//                     {type === 'quarterly' ? 'Quarterly' :
//                       type === 'monthly' ? 'Monthly' :
//                         type === 'weekly' ? 'Weekly' :
//                           type === 'today' ? 'Today' :
//                             type === 'custom' ? 'Custom Date' :
//                               'Yearly'}
//                   </button>
//                 ))}
//               </div>

//               {/* Clear and Export buttons together */}
//               <div style={{
//                 display: 'flex',
//                 gap: '10px',
//                 marginLeft: '20px'
//               }}>
//                 <button
//                   onClick={clearAllFilters}
//                   style={{
//                     padding: '10px 10px',
//                     background: '#ff6b6b',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     whiteSpace: 'nowrap',
//                     minWidth: '80px'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   className="export-button"
//                   onClick={exportToCSV}
//                   style={{
//                     padding: '10px 10px',
//                     background: '#b15dc6',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     whiteSpace: 'nowrap',
//                     minWidth: '120px'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
//                 >
//                   Export to CSV
//                 </button>
//               </div>
//             </div>

//             {/* For medium screens: Yearly/Quarterly/Monthly in first line, Weekly/Today/Custom in second line */}
//             <div style={{
//               display: window.innerWidth >= 768 && window.innerWidth < 1024 ? 'flex' : 'none',
//               flexDirection: 'column',
//               gap: '12px'
//             }}>
//               {/* First row: Yearly, Quarterly, Monthly */}
//               <div style={{
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 gap: '10px',
//                 justifyContent: 'center'
//               }}>
//                 {['yearly', 'quarterly', 'monthly'].map((type) => (
//                   <button
//                     key={type}
//                     onClick={() => applyDateFilter(type)}
//                     style={{
//                       padding: '5px 10px',
//                       background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
//                       color: dateFilterType === type ? 'white' : '#374151',
//                       border: 'none',
//                       borderRadius: '8px',
//                       fontSize: '14px',
//                       fontWeight: '500',
//                       cursor: 'pointer',
//                       transition: 'all 0.2s',
//                       textTransform: 'capitalize',
//                       minWidth: '80px',
//                       whiteSpace: 'nowrap'
//                     }}
//                     onMouseEnter={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#e5e7eb';
//                       }
//                     }}
//                     onMouseLeave={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#f3f4f6';
//                       }
//                     }}
//                   >
//                     {type === 'quarterly' ? 'Quarterly' :
//                       type === 'monthly' ? 'Monthly' :
//                         'Yearly'}
//                   </button>
//                 ))}
//               </div>

//               {/* Second row: Weekly, Today, Custom, Clear, Export */}
//               <div style={{
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 gap: '10px',
//                 justifyContent: 'center'
//               }}>
//                 {['weekly', 'today', 'custom'].map((type) => (
//                   <button
//                     key={type}
//                     onClick={() => {
//                       if (type === 'custom') {
//                         setShowCustomPopup(true);
//                         setTempStartDate(customStartDate || "");
//                         setTempEndDate(customEndDate || "");
//                       } else {
//                         applyDateFilter(type);
//                       }
//                     }}
//                     style={{
//                       padding: '5px 10px',
//                       background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
//                       color: dateFilterType === type ? 'white' : '#374151',
//                       border: 'none',
//                       borderRadius: '8px',
//                       fontSize: '14px',
//                       fontWeight: '500',
//                       cursor: 'pointer',
//                       transition: 'all 0.2s',
//                       textTransform: 'capitalize',
//                       minWidth: '80px',
//                       whiteSpace: 'nowrap',
//                       height: '31px'
//                     }}
//                     onMouseEnter={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#e5e7eb';
//                       }
//                     }}
//                     onMouseLeave={e => {
//                       if (dateFilterType !== type) {
//                         e.currentTarget.style.background = '#f3f4f6';
//                       }
//                     }}
//                   >
//                     {type === 'weekly' ? 'Weekly' :
//                       type === 'today' ? 'Today' :
//                         'Custom Date'}
//                   </button>
//                 ))}

//                 <button
//                   onClick={clearAllFilters}
//                   style={{
//                     padding: '5px 10px',
//                     background: '#ff6b6b',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     minWidth: '80px',
//                     whiteSpace: 'nowrap',
//                     height: '31px'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   className="export-button"
//                   onClick={exportToCSV}
//                   style={{
//                     padding: '5px 10px',
//                     background: '#b15dc6',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     minWidth: '120px',
//                     whiteSpace: 'nowrap',
//                     height: '31px'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
//                 >
//                   Export to CSV
//                 </button>
//               </div>
//             </div>

//             {/* For small screens: All buttons stacked */}
//             <div style={{
//               display: window.innerWidth < 768 ? 'flex' : 'none',
//               flexDirection: 'column',
//               gap: '10px'
//             }}>
//               {['yearly', 'quarterly', 'monthly', 'weekly', 'today', 'custom'].map((type) => (
//                 <button
//                   key={type}
//                   onClick={() => {
//                     if (type === 'custom') {
//                       setShowCustomPopup(true);
//                       setTempStartDate(customStartDate || "");
//                       setTempEndDate(customEndDate || "");
//                     } else {
//                       applyDateFilter(type);
//                     }
//                   }}
//                   style={{
//                     padding: '12px 20px',
//                     background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
//                     color: dateFilterType === type ? 'white' : '#374151',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     transition: 'all 0.2s',
//                     textTransform: 'capitalize',
//                     width: '100%',
//                     textAlign: 'center'
//                   }}
//                   onMouseEnter={e => {
//                     if (dateFilterType !== type) {
//                       e.currentTarget.style.background = '#e5e7eb';
//                     }
//                   }}
//                   onMouseLeave={e => {
//                     if (dateFilterType !== type) {
//                       e.currentTarget.style.background = '#f3f4f6';
//                     }
//                   }}
//                 >
//                   {type === 'quarterly' ? 'Quarterly' :
//                     type === 'monthly' ? 'Monthly' :
//                       type === 'weekly' ? 'Weekly' :
//                         type === 'today' ? 'Today' :
//                           type === 'custom' ? 'Custom Date' :
//                             'Yearly'}
//                 </button>
//               ))}

//               {/* Clear and Export buttons stacked for mobile */}
//               <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
//                 <button
//                   onClick={clearAllFilters}
//                   style={{
//                     padding: '12px 20px',
//                     background: '#ff6b6b',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     width: '50%',
//                     textAlign: 'center'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   className="export-button"
//                   onClick={exportToCSV}
//                   style={{
//                     padding: '12px 20px',
//                     background: '#b15dc6',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     cursor: 'pointer',
//                     transition: 'background 0.2s',
//                     width: '50%',
//                     textAlign: 'center'
//                   }}
//                   onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
//                   onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
//                 >
//                   Export to CSV
//                 </button>
//               </div>
//             </div>

//             {/* Custom Date Range Inputs - shown only when Custom is selected */}
//             {showCustomPopup && (
//               <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 zIndex: 1000,
//                 backdropFilter: 'blur(2px)'
//               }}>
//                 <div
//                   ref={popupRef}
//                   style={{
//                     backgroundColor: 'white',
//                     borderRadius: '12px',
//                     padding: '24px',
//                     minWidth: window.innerWidth < 768 ? '90%' : '400px',
//                     maxWidth: '500px',
//                     boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
//                     animation: 'fadeInScale 0.3s ease'
//                   }}
//                 >
//                   <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: '0px'
//                   }}>
//                     <h3 style={{ margin: 0, fontSize: '18px', color: '#374151' }}>
//                       Select Custom Date Range
//                     </h3>
//                     <button
//                       onClick={() => setShowCustomPopup(false)}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         fontSize: '20px',
//                         cursor: 'pointer',
//                         color: '#6B7280',
//                         padding: '5px',
//                         borderRadius: '50%',
//                         width: '30px',
//                         height: '30px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                       onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
//                       onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
//                     >
//                       ×
//                     </button>
//                   </div>

//                   <div style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: '16px',
//                     marginBottom: '24px'
//                   }}>
//                     <div>
//                       <label style={{
//                         display: 'block',
//                         fontSize: '14px',
//                         fontWeight: '500',
//                         color: '#374151',
//                         marginBottom: '8px',
//                         marginTop: "0px",
//                       }}>
//                         From Date
//                       </label>
//                       <input
//                         type="date"
//                         value={tempStartDate}
//                         onChange={(e) => setTempStartDate(e.target.value)}
//                         max={new Date().toISOString().split('T')[0]}
//                         style={{
//                           width: '100%',
//                           padding: '10px 12px',
//                           border: '1px solid #d1d5db',
//                           borderRadius: '6px',
//                           fontSize: '14px',
//                           outline: 'none',
//                           transition: 'border-color 0.2s',
//                           boxSizing: 'border-box'
//                         }}
//                         onFocus={e => e.target.style.borderColor = '#b15dc6'}
//                         onBlur={e => e.target.style.borderColor = '#d1d5db'}
//                       />
//                     </div>

//                     <div>
//                       <label style={{
//                         display: 'block',
//                         fontSize: '14px',
//                         fontWeight: '500',
//                         color: '#374151',
//                         marginBottom: '8px',
//                         marginTop: "0px",
//                       }}>
//                         To Date
//                       </label>
//                       <input
//                         type="date"
//                         value={tempEndDate}
//                         onChange={(e) => setTempEndDate(e.target.value)}
//                         max={new Date().toISOString().split('T')[0]}
//                         min={tempStartDate}
//                         style={{
//                           width: '100%',
//                           padding: '10px 12px',
//                           border: '1px solid #d1d5db',
//                           borderRadius: '6px',
//                           fontSize: '14px',
//                           outline: 'none',
//                           transition: 'border-color 0.2s',
//                           boxSizing: 'border-box'
//                         }}
//                         onFocus={e => e.target.style.borderColor = '#b15dc6'}
//                         onBlur={e => e.target.style.borderColor = '#d1d5db'}
//                       />
//                     </div>
//                   </div>

//                   <div style={{
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     gap: '12px'
//                   }}>
//                     <button
//                       onClick={() => {
//                         setShowCustomPopup(false);
//                         setTempStartDate("");
//                         setTempEndDate("");
//                       }}
//                       style={{
//                         padding: '10px 20px',
//                         background: 'transparent',
//                         color: '#6B7280',
//                         border: '1px solid #d1d5db',
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         fontWeight: '500',
//                         cursor: 'pointer',
//                         transition: 'all 0.2s',
//                         minWidth: '80px'
//                       }}
//                       onMouseEnter={e => {
//                         e.currentTarget.style.backgroundColor = '#f3f4f6';
//                         e.currentTarget.style.borderColor = '#9ca3af';
//                       }}
//                       onMouseLeave={e => {
//                         e.currentTarget.style.backgroundColor = 'transparent';
//                         e.currentTarget.style.borderColor = '#d1d5db';
//                       }}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={() => {
//                         if (tempStartDate && tempEndDate) {
//                           setCustomStartDate(tempStartDate);
//                           setCustomEndDate(tempEndDate);
//                           setDateFilterType('custom');
//                           setShowCustomPopup(false);
//                         }
//                       }}
//                       disabled={!tempStartDate || !tempEndDate}
//                       style={{
//                         padding: '10px 20px',
//                         background: (!tempStartDate || !tempEndDate) ? '#9ca3af' : '#b15dc6',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '6px',
//                         fontSize: '14px',
//                         fontWeight: '500',
//                         cursor: (!tempStartDate || !tempEndDate) ? 'not-allowed' : 'pointer',
//                         transition: 'background 0.2s',
//                         minWidth: '80px'
//                       }}
//                       onMouseEnter={e => {
//                         if (tempStartDate && tempEndDate) {
//                           e.currentTarget.style.background = '#9d4edd';
//                         }
//                       }}
//                       onMouseLeave={e => {
//                         if (tempStartDate && tempEndDate) {
//                           e.currentTarget.style.background = '#b15dc6';
//                         }
//                       }}
//                     >
//                       Apply
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//         </div>

//         {/* Income Summary Cards */}
//         <div className="status-overview">
//           {[
//             { title: "Total Income", value: totals.totalIncome, color: "#2c6eaa" },
//             { title: "Wallet Income", value: totals.walletIncome, color: "#4ecdc4" },
//             { title: "Online Income", value: totals.onlineIncome, color: "#45b7d1" },
//             { title: "Cash Income", value: totals.cashIncome, color: "#96ceb4" },
//           ].map((card, idx) => (
//             <div key={idx} style={{ background: card.color, color: "#fff", padding: "5px" }} className="status-card dine-in">
//               <h4 style={{ display: 'flex', justifyContent: "center", fontSize: "16px", margin: "10px 0" }}>
//                 {card.title}
//               </h4>
//               <p style={{
//                 fontWeight: "bold",
//                 display: 'flex',
//                 justifyContent: "center",
//                 fontSize: "18px",
//                 margin: "10px 0"
//               }}>
//                 ₹{card.value.toLocaleString("en-IN")}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* Table Section */}
//         < div className="payment-history-container" >
//           <style>
//             {`
// .payment-history-container {
//   box-sizing: border-box;
//   width: 100%;
//   max-width: 100%;
// }

// .filters {
//   margin-bottom: 20px;
//   width: 100%;
// }

// .filters-single-line {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 15px;
//   flex-wrap: nowrap;
//   width: 100% !important;
// }

// .category-search {
//   flex: 0 0 auto;
// }

// .category-search input {
//   padding: 10px 14px;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   background-color: white;
//   font-size: 14px;
//   min-width: 200px;
//   outline: none;
//   transition: border-color 0.2s;
// }

// .category-search input:focus {
//   border-color: #b15cd6;
//   box-shadow: 0 0 0 2px rgba(177, 92, 214, 0.2);
// }

// .export-button {
//   padding: 10px 20px;
//   background-color: #b15cd6;
//   color: #fff;
//   border: none;
//   border-radius: 8px;
//   font-weight: 600;
//   cursor: pointer;
//   white-space: nowrap;
//   flex: 0 0 auto;
//   transition: background 0.2s;
// }

// .export-button:hover {
//   background-color: #9d4edd;
// }

// .table-wrapper {
//   width: 100%;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
//   background: #fff;
//   border-radius: 12px;
//   border: 1px solid #E5E7EB;
//   box-shadow: 0 2px 8px rgba(0,0,0,0.04);
// }

// table {
//   width: 100%;
//   min-width: 850px;
//   border-collapse: collapse;
// }

// th, td {
//   border: 1px solid #E5E7EB;
//   padding: 12px 16px;
//   font-size: 14px;
//   text-align: left;
//   white-space: nowrap;
// }

// th {
//   background-color: #b15dc6;
//   font-weight: 600;
//   font-size: 14px;
//   color: white;
//   position: sticky;
//   top: 0;
// }

// tr:nth-child(even) {
//   background-color: #fafafa;
// }

// tr:nth-child(odd) {
//   background-color: #ffffff;
// }

// tr:hover {
//   background-color: #f3f4f6;
// }

// @media screen and (max-width: 768px) {
//   .payment-history-container {
//     max-width: 100%;
//     padding: 0px;
//   }

//   .filters-single-line {
//     flex-direction: column;
//     align-items: stretch;
//     gap: 12px;
//   }

//   .category-search {
//     width: 100%;
//     display: flex;
//     justify-content: center;
//   }

//   .category-search input {
//     width: 100%;
//     max-width: 100%;
//   }

//   .export-button {
//     width: 100%;
//     max-width: 100%;
//     align-self: center;
//   }

//   table {
//     min-width: 600px;
//   }
  
//   .status-overview {
//     flex-direction: column;
//     gap: 12px;
//   }
// }

// .my-container {
//   overflow-y: scroll;
//   -ms-overflow-style: none; 
//   scrollbar-width: none;
// }

// .my-container::-webkit-scrollbar {
//   display: none;
// }

// .tab-content {
//   width: 100%;
//   max-width: 1100px;
// }
//   @keyframes fadeInScale {
//   0% {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   100% {
//     opacity: 1;
//     transform: scale(1);
//   }
// }
//   @media (min-width: 999px) {
//     .export-button {
//         margin-left: 0px !important;
//         margin-top: 0px !important;
//     }
// }

// /* Status colors */
// .status-pending { color: #f59e0b; }
// .status-completed { color: #10b981; }
// .status-cancelled { color: #ef4444; }
// .status-processing { color: #3b82f6; }
// `}
//           </style>
// {/* 
//           <div className="filters"
//             style={{
//               overflow: "auto",
//               scrollbarWidth: "none",
//               overflowY: "hidden",
//               marginBottom: "10px"
//             }}>
//             <div className="filters-single-line">
            
//               <div className="category-search" style={{ display: "none" }}>
//                 <input
//                   type="text"
//                   placeholder="Search by category..."
//                   value={selectedCategory === "All Categories" ? "" : selectedCategory}
//                   onChange={(e) => {
//                     const value = e.target.value.trim();
//                     if (value === "") {
//                       setSelectedCategory("All Categories");
//                     } else {
//                       setSelectedCategory(value);
//                     }
//                   }}
//                   style={{
//                     padding: "10px 14px",
//                     border: "1px solid #ddd",
//                     borderRadius: "8px",
//                     fontSize: "14px",
//                     minWidth: "200px",
//                     outline: "none"
//                   }}
//                 />
//               </div>

//               <button
//                 className="export-button"
//                 onClick={exportToCSV}
//                 style={{
//                   padding: "10px 10px",
//                   background: "#b15dc6",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   transition: "background 0.2s"
//                 }}
//                 onMouseEnter={e => e.currentTarget.style.background = "#9d4edd"}
//                 onMouseLeave={e => e.currentTarget.style.background = "#b15dc6"}
//               >
//                 Export to CSV
//               </button>
//             </div>
//           </div> */}

//           <div className="table-wrapper">
//             <table style={{ marginTop: "0px" }}>
//               <thead>
//                 <tr>
//                   <th style={{ textAlign: "center" }}>OrderID</th>
//                   <th style={{ textAlign: "center" }}>Date & Time</th>
//                   <th style={{ textAlign: "center" }}>Name</th>
//                   <th style={{ textAlign: "center" }}>Payment</th>
//                   <th style={{ textAlign: "center" }}>Transaction ID</th>
//                   <th style={{ textAlign: "center" }}>Status</th>
//                   <th style={{ textAlign: "center" }}>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredData.length === 0 ? (
//                   <tr>
//                     <td colSpan="7" style={{ textAlign: "center", padding: "40px" }}>
//                       <div style={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         gap: '12px',
//                         color: '#6B7280'
//                       }}>
//                         <div style={{ fontSize: '48px' }}>📊</div>
//                         <h3 style={{ margin: 0, fontSize: '18px', color: '#374151' }}>
//                           No orders found
//                         </h3>
//                         <p style={{ margin: 0, fontSize: '14px' }}>
//                           {selectedDate || customStartDate || selectedCategory !== "All Categories"
//                             ? `Try adjusting your filters`
//                             : 'Start taking orders to see data here'}
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredData.map((item, index) => (
//                     <tr key={index}>
//                       <td style={{ textAlign: "center" }} >{item.orderId}</td>
//                       <td style={{ textAlign: "center" }}>{new Date(item.orderDateAndTime).toLocaleString()}</td>
//                       <td style={{ textAlign: "center" }}>{getUserName(item)}</td>
//                       <td style={{ textAlign: "center" }}>{getPaymentMethod(item)}</td>
//                       <td style={{ textAlign: "center" }}>{getTransactionId(item)}</td>
//                       <td style={{ textAlign: "center" }}>
//                         <span className={`status-${getOrderStatus(item).toLowerCase().replace(/\s+/g, '-')}`}>
//                           {getOrderStatus(item)}
//                         </span>
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         ₹{Math.round(item.grandTotal || 0).toLocaleString("en-IN")}
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     ),
//     "Cash Billing": <Cashbilling />,
//     Settlement: <Settlement />,
//     WalletApproval: <WalletAdd />,
//   };

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-lg-12 col-md-12 col-sm-12">
//           <div className="left-column">
//             <div className="tabs-wrapperpayment">
//               <div style={{ textAlign: 'center' }}>
//                 {Object.keys(tabContent).map((label) => (
//                   <button
//                     key={label}
//                     style={{
//                       backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
//                       border: 'none',
//                       borderRadius: '10px',
//                       width: window.innerWidth < 1100 ? '110px' : 'auto',
//                       height: '40px',
//                       color: 'black',
//                       fontWeight: 'bold',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s ease',
//                       margin:window.innerWidth < 1100 ? '5px': '10px',
//                       fontSize:window.innerWidth<1100 ? "0.8rem" : " ",
//                     }}
//                     className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
//                     onClick={() => setActiveTab(label)}
//                   >
//                     {label}
//                   </button>
//                 ))}
//               </div>
//               <div
//                 className="tab-content my-container"
//                 style={{
//                   overflow: 'auto',
//                   height: window.innerHeight <= 550 ? "60vh" : window.innerHeight <= 600 ? "65vh" : window.innerHeight > 600 ? "70vh" : containerHeight,
//                   scrollbarWidth: "thin",
//                   msOverflowStyle: "none",
//                   maxWidth: '1100px',
//                   padding: '20px',
//                   paddingTop: "5px",
//                   display:window.innerWidth<500 ? "90vw" : " ",
//                 }}
//               >
//                 {tabContent[activeTab]}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Management3;






import './Management3.css';
import axios from 'axios';
import Cashbilling from './Cashbilling';
import "./Company.css";
import "./Style.css";
import Settlement from './Settlement';
import WalletAdd from './WalletAdd';
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import { Approval } from '@mui/icons-material';
import React, { useEffect, useState, useMemo, useRef } from 'react';

const Management3 = () => {
  const [activeTab, setActiveTab] = useState('Overview');
  const [vendorId, setVendorId] = useState(null);
  const isMobile = window.innerWidth < 768;
  const [selectedDate, setSelectedDate] = useState("");
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { showLoader, hideLoader } = useLoader();
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");
  // Inside your component:
  const popupRef = useRef(null);
  // Add useEffect to handle outside clicks
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowCustomPopup(false);
      }
    };

    if (showCustomPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCustomPopup]);

  // Date filter states
  const [dateFilterType, setDateFilterType] = useState('today'); // today, monthly, quarterly, yearly, custom
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  // Category filter states
  const [categories, setCategories] = useState(["All Categories"]);
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  const [dishCategoryMap, setDishCategoryMap] = useState({});
  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '410px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '430px' // Between 1400px and 1599px
          : '450px'; // Above 1600px

  // Helper function to determine if order is completed
  const isOrderCompleted = (order) => {
    const paymentMethod = order.paymentMethod?.toLowerCase();
    const orderStatus = (order.status || '').toUpperCase();
    const cashStatus = (order.cashStatus || '').toUpperCase();

    // Always exclude cancelled orders
    const isCancelled = orderStatus === 'CANCELLED' || cashStatus === 'CANCELLED';
    if (isCancelled) {
      return false;
    }

    // For ONLINE payments - payment is already done when order is placed
    // So count all online payment orders (except cancelled)
    if (paymentMethod === 'online_payment') {
      return true; // Online payment already completed
    }

    // For CASH payments - only count if cash is accepted
    if (paymentMethod === 'cash') {
      return cashStatus === 'ACCEPT';
    }

    // For WALLET payments - payment is already done
    if (paymentMethod === 'maamaas_wallet' || paymentMethod === 'wallet') {
      return true; // Wallet payment already completed
    }

    // Default: count if not cancelled
    return true;
  };

  // Calculate totals based on filtered data
  const totals = useMemo(() => {
    let walletIncome = 0, onlineIncome = 0, cashIncome = 0;

    filteredData.forEach(order => {
      const amount = order.grandTotal || 0;
      const method = order.paymentMethod;
      const orderStatus = (order.status || '').toUpperCase();

      // Skip cancelled orders (will be refunded)
      if (orderStatus === 'CANCELLED') {
        return; // Skip this order
      }

      // Count based on payment method
      if (method === "Online_Payment") {
        onlineIncome += amount;
      } else if (method === "Cash") {
        cashIncome += amount;
      } else if (method === "Maamaas_Wallet" || method?.toLowerCase() === "wallet") {
        walletIncome += amount;
      }
    });

    const totalIncome = walletIncome + onlineIncome + cashIncome;

    return {
      walletIncome,
      onlineIncome,
      cashIncome,
      totalIncome
    };
  }, [filteredData]);


  const applyDateFilter = (type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999); // End of today

    let startDate = new Date();

    switch (type) {
      case 'today':
        // Today only - from start of today to end of today
        startDate = new Date(today);
        setSelectedDate(today.toISOString().split('T')[0]);
        setCustomStartDate(startDate.toISOString().split('T')[0]);
        setCustomEndDate(endDate.toISOString().split('T')[0]);
        break;

      case 'weekly':
        // Last 7 days (including today)
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        startDate.setHours(0, 0, 0, 0);
        setSelectedDate("");
        setCustomStartDate(startDate.toISOString().split('T')[0]);
        setCustomEndDate(endDate.toISOString().split('T')[0]);
        break;

      case 'monthly':
        // This month
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate.setHours(0, 0, 0, 0);
        setSelectedDate("");
        setCustomStartDate(startDate.toISOString().split('T')[0]);
        setCustomEndDate(endDate.toISOString().split('T')[0]);
        break;

      case 'quarterly':
        // Last 3 months
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 2);
        startDate.setDate(1);
        startDate.setHours(0, 0, 0, 0);
        setSelectedDate("");
        setCustomStartDate(startDate.toISOString().split('T')[0]);
        setCustomEndDate(endDate.toISOString().split('T')[0]);
        break;

      case 'yearly':
        // This year
        startDate = new Date(today.getFullYear(), 0, 1);
        startDate.setHours(0, 0, 0, 0);
        setSelectedDate("");
        setCustomStartDate(startDate.toISOString().split('T')[0]);
        setCustomEndDate(endDate.toISOString().split('T')[0]);
        break;

      case 'custom':
        // Custom date - will be handled separately
        setSelectedDate("");
        break;
    }

    setDateFilterType(type);
  };

  // Clear all filters
  // Clear all filters
  const clearAllFilters = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    setSelectedDate(today.toISOString().split('T')[0]);
    setCustomStartDate("");
    setCustomEndDate("");
    setDateFilterType('today');
    setSelectedCategory("All Categories");
  };

  // Fetch orders
  useEffect(() => {
    if (!vendorId) return;
    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token is missing");
        return;
      }

      try {
        showLoader();
        const res = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const orders = res.data || [];
        setAllOrders(orders);
        setFilteredData(orders);

      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        hideLoader();
      }
    };

    fetchOrders();
  }, [vendorId]);

  // Fetch categories and create dish-to-category mapping
  useEffect(() => {
    if (!vendorId) return;

    const fetchCategoriesAndMapping = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token is missing");
        return;
      }

      try {
        showLoader();
        const res = await axios.get(
          `https://backend.maamaas.com/food/api/dishes/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const dishes = res.data || [];

        // Create mapping of dishName to category name
        const categoryMap = {};
        const categoriesSet = new Set();

        dishes.forEach(dish => {
          if (dish.parentId === 0) {
            // This is a category
            categoriesSet.add(dish.dishName);
          } else {
            // This is a dish - find its category
            const category = dishes.find(cat => cat.dishId === dish.parentId);
            if (category) {
              categoryMap[dish.dishName] = category.dishName;
            }
          }
        });

        setDishCategoryMap(categoryMap);
        setCategories(["All Categories", ...Array.from(categoriesSet).sort()]);

      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        hideLoader();
      }
    };

    fetchCategoriesAndMapping();
  }, [vendorId]);


  useEffect(() => {
    if (!allOrders.length) {
      setFilteredData([]);
      return;
    }

    const filtered = allOrders.filter((order) => {
      // Parse order date
      let orderDate;
      try {
        orderDate = new Date(order.orderDateAndTime);
        if (isNaN(orderDate.getTime())) {
          return false; // Invalid date
        }
      } catch (error) {
        console.error("Error parsing date:", order.orderDateAndTime);
        return false;
      }

      const orderDateStr = orderDate.toISOString().split('T')[0];
      const orderDateTime = orderDate.getTime();

      // Date filter logic
      let dateMatch = false;

      // Create date objects for comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const orderDateOnly = new Date(orderDate);
      orderDateOnly.setHours(0, 0, 0, 0);

      if (dateFilterType === 'today') {
        // Check if order date is today
        dateMatch = orderDateOnly.getTime() === today.getTime();
      }
      else if (customStartDate && customEndDate) {
        // For date ranges
        const start = new Date(customStartDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(customEndDate);
        end.setHours(23, 59, 59, 999);

        dateMatch = orderDate >= start && orderDate <= end;
      }

      // Category filter
      let categoryMatch = true;
      if (selectedCategory !== "All Categories") {
        categoryMatch = order.order && order.order.some((item) => {
          const dishCategory = dishCategoryMap[item.dishName];
          if (!dishCategory) return false;
          return dishCategory.toLowerCase().includes(selectedCategory.toLowerCase());
        });
      }

      return dateMatch && categoryMatch;
    });

    setFilteredData(filtered);
  }, [selectedDate, customStartDate, customEndDate, selectedCategory, allOrders, dishCategoryMap, dateFilterType]);



  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  // Apply today filter by default on component mount
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);

    setSelectedDate(today.toISOString().split('T')[0]);
    setCustomStartDate(today.toISOString().split('T')[0]);
    setCustomEndDate(endDate.toISOString().split('T')[0]);
    setTempStartDate(today.toISOString().split('T')[0]); // Add this
    setTempEndDate(endDate.toISOString().split('T')[0]); // Add this
    setDateFilterType('today');
  }, []);

  // Helper functions for data display
  const getUserName = (order) => {
    return order.userName || "Guest";
  };

  const getTransactionId = (order) => {
    const paymentMethod = order.paymentMethod?.toLowerCase();
    if (paymentMethod === "cash") {
      return "-";
    }
    return order.transactionId || "-";
  };

  const getOrderStatus = (order) => {
    const status = order.status || order.cashStatus || order.paymentStatus || "Pending";
    return status.charAt(0) + status.slice(1).toLowerCase().replace(/_/g, ' ');
  };

  const getPaymentMethod = (order) => {
    const method = order.paymentMethod;
    if (!method) return "Unknown";

    switch (method.toLowerCase()) {
      case "online_payment":
        return "Online";
      case "maamaas_wallet":
        return "Wallet";
      case "cash":
        return "Cash";
      default:
        return method;
    }
  };

  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    const headers = [
      "Order ID",
      "Date",
      "Category",
      "Type",
      "Name",
      "Payment",
      "Order Status",
      "Amount",
    ];

    const rows = filteredData.map((item, index) => [
      index + 1,
      item.orderId,
      new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
      item.appType || "-",
      item.orderType || item.orderService || "-",
      getUserName(item),
      getPaymentMethod(item),
      getOrderStatus(item),
      Math.round(item.grandTotal || 0),
    ]);

    const csvContent =
      [headers, ...rows]
        .map((row) => row.map((v) => `"${v}"`).join(","))
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `orders_${selectedDate || new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Get display text for current date filter
  // Get display text for current date filter
  const getDateFilterDisplay = () => {
    switch (dateFilterType) {
      case 'today':
        return formatDisplayDate(selectedDate) || 'Today';
      case 'weekly':
        return `Last 7 Days (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
      case 'monthly':
        return `This Month (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
      case 'quarterly':
        return `Last 3 Months (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
      case 'yearly':
        return `This Year (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
      case 'custom':
        if (customStartDate && customEndDate) {
          return `Custom (${formatDisplayDate(customStartDate)} - ${formatDisplayDate(customEndDate)})`;
        }
        return 'Select Custom Dates';
      default:
        return 'Today';
    }
  };

  // Overview Tab Content
  const tabContent = {
    Overview: (
      <div style={{ marginTop: "0px" }}>
        {/* Date Filter Buttons */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '5px',
          marginBottom: '10px',
          border: '0px solid #E5E7EB'
        }}>
          {/* Main container for date filter buttons */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            {/* Date filter buttons - responsive layout */}

            {/* For large screens: All buttons in one line */}
            <div style={{
              display: window.innerWidth < 1024 ? 'none' : 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px'
            }}>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                flex: 1
              }}>
                {['yearly', 'quarterly', 'monthly', 'weekly', 'today', 'custom'].map((type) => (
                  <button
                    key={type}
                    onClick={() => {
                      if (type === 'custom') {
                        setShowCustomPopup(true);
                        setTempStartDate(customStartDate || "");
                        setTempEndDate(customEndDate || "");
                      } else {
                        applyDateFilter(type);
                      }
                    }}
                    style={{
                      padding: '10px 10px',
                      background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
                      color: dateFilterType === type ? 'white' : '#374151',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      textTransform: 'capitalize',
                      minWidth: '80px',
                      whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#e5e7eb';
                      }
                    }}
                    onMouseLeave={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#f3f4f6';
                      }
                    }}
                  >
                    {type === 'quarterly' ? 'Quarterly' :
                      type === 'monthly' ? 'Monthly' :
                        type === 'weekly' ? 'Weekly' :
                          type === 'today' ? 'Today' :
                            type === 'custom' ? 'Custom Date' :
                              'Yearly'}
                  </button>
                ))}
              </div>

              {/* Clear and Export buttons together */}
              <div style={{
                display: 'flex',
                gap: '10px',
                marginLeft: '20px'
              }}>
                <button
                  onClick={clearAllFilters}
                  style={{
                    padding: '10px 10px',
                    background: '#ff6b6b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    whiteSpace: 'nowrap',
                    minWidth: '80px'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
                  onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
                >
                  Clear
                </button>
                <button
                  className="export-button"
                  onClick={exportToCSV}
                  style={{
                    padding: '10px 10px',
                    background: '#b15dc6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    whiteSpace: 'nowrap',
                    minWidth: '120px'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
                  onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
                >
                  Export to CSV
                </button>
              </div>
            </div>

            {/* For medium screens: Yearly/Quarterly/Monthly in first line, Weekly/Today/Custom in second line */}
            <div style={{
              display: window.innerWidth >= 768 && window.innerWidth < 1024 ? 'flex' : 'none',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {/* First row: Yearly, Quarterly, Monthly */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                justifyContent: 'center'
              }}>
                {['yearly', 'quarterly', 'monthly'].map((type) => (
                  <button
                    key={type}
                    onClick={() => applyDateFilter(type)}
                    style={{
                      padding: '5px 10px',
                      background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
                      color: dateFilterType === type ? 'white' : '#374151',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      textTransform: 'capitalize',
                      minWidth: '80px',
                      whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#e5e7eb';
                      }
                    }}
                    onMouseLeave={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#f3f4f6';
                      }
                    }}
                  >
                    {type === 'quarterly' ? 'Quarterly' :
                      type === 'monthly' ? 'Monthly' :
                        'Yearly'}
                  </button>
                ))}
              </div>

              {/* Second row: Weekly, Today, Custom, Clear, Export */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                justifyContent: 'center'
              }}>
                {['weekly', 'today', 'custom'].map((type) => (
                  <button
                    key={type}
                    onClick={() => {
                      if (type === 'custom') {
                        setShowCustomPopup(true);
                        setTempStartDate(customStartDate || "");
                        setTempEndDate(customEndDate || "");
                      } else {
                        applyDateFilter(type);
                      }
                    }}
                    style={{
                      padding: '5px 10px',
                      background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
                      color: dateFilterType === type ? 'white' : '#374151',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      textTransform: 'capitalize',
                      minWidth: '80px',
                      whiteSpace: 'nowrap',
                      height: '31px'
                    }}
                    onMouseEnter={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#e5e7eb';
                      }
                    }}
                    onMouseLeave={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#f3f4f6';
                      }
                    }}
                  >
                    {type === 'weekly' ? 'Weekly' :
                      type === 'today' ? 'Today' :
                        'Custom Date'}
                  </button>
                ))}

                <button
                  onClick={clearAllFilters}
                  style={{
                    padding: '5px 10px',
                    background: '#ff6b6b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    minWidth: '80px',
                    whiteSpace: 'nowrap',
                    height: '31px'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
                  onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
                >
                  Clear
                </button>
                <button
                  className="export-button"
                  onClick={exportToCSV}
                  style={{
                    padding: '5px 10px',
                    background: '#b15dc6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    minWidth: '120px',
                    whiteSpace: 'nowrap',
                    height: '31px'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
                  onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
                >
                  Export to CSV
                </button>
              </div>
            </div>

            {/* For small screens: Filter buttons horizontal scroll */}
            <div style={{
              display: window.innerWidth < 768 ? 'flex' : 'none',
              flexDirection: 'column',
              gap: '10px'
            }}>
              {/* Filter buttons - horizontal scroll */}
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                overflowX: 'auto',
                paddingBottom: '10px',
                whiteSpace: 'nowrap',
                scrollbarWidth: 'thin',
                msOverflowStyle: 'auto'
              }}>
                {['yearly', 'quarterly', 'monthly', 'weekly', 'today', 'custom'].map((type) => (
                  <button
                    key={type}
                    onClick={() => {
                      if (type === 'custom') {
                        setShowCustomPopup(true);
                        setTempStartDate(customStartDate || "");
                        setTempEndDate(customEndDate || "");
                      } else {
                        applyDateFilter(type);
                      }
                    }}
                    style={{
                      padding: '12px 20px',
                      background: dateFilterType === type ? '#b15dc6' : '#f3f4f6',
                      color: dateFilterType === type ? 'white' : '#374151',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      textTransform: 'capitalize',
                      minWidth: 'max-content',
                      flexShrink: 0,
                      textAlign: 'center'
                    }}
                    onMouseEnter={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#e5e7eb';
                      }
                    }}
                    onMouseLeave={e => {
                      if (dateFilterType !== type) {
                        e.currentTarget.style.background = '#f3f4f6';
                      }
                    }}
                  >
                    {type === 'quarterly' ? 'Quarterly' :
                      type === 'monthly' ? 'Monthly' :
                        type === 'weekly' ? 'Weekly' :
                          type === 'today' ? 'Today' :
                            type === 'custom' ? 'Custom Date' :
                              'Yearly'}
                  </button>
                ))}
              </div>

              {/* Clear and Export buttons stacked below */}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={clearAllFilters}
                  style={{
                    padding: '12px 20px',
                    background: '#ff6b6b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    width: '50%',
                    textAlign: 'center'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#ff5252'}
                  onMouseLeave={e => e.currentTarget.style.background = '#ff6b6b'}
                >
                  Clear
                </button>
                <button
                  className="export-button"
                  onClick={exportToCSV}
                  style={{
                    padding: '12px 20px',
                    background: '#b15dc6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    width: '50%',
                    textAlign: 'center'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#9d4edd'}
                  onMouseLeave={e => e.currentTarget.style.background = '#b15dc6'}
                >
                  Export to CSV
                </button>
              </div>
            </div>

            {/* Custom Date Range Inputs - shown only when Custom is selected */}
            {showCustomPopup && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(2px)'
              }}>
                <div
                  ref={popupRef}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    minWidth: window.innerWidth < 768 ? '90%' : '400px',
                    maxWidth: '500px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
                    animation: 'fadeInScale 0.3s ease'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0px'
                  }}>
                    <h3 style={{ margin: 0, fontSize: '18px', color: '#374151' }}>
                      Select Custom Date Range
                    </h3>
                    <button
                      onClick={() => setShowCustomPopup(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '20px',
                        cursor: 'pointer',
                        color: '#6B7280',
                        padding: '5px',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      ×
                    </button>
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    marginBottom: '24px'
                  }}>
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#374151',
                        marginBottom: '8px',
                        marginTop: "0px",
                      }}>
                        From Date
                      </label>
                      <input
                        type="date"
                        value={tempStartDate}
                        onChange={(e) => setTempStartDate(e.target.value)}
                        max={new Date().toISOString().split('T')[0]}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '14px',
                          outline: 'none',
                          transition: 'border-color 0.2s',
                          boxSizing: 'border-box'
                        }}
                        onFocus={e => e.target.style.borderColor = '#b15dc6'}
                        onBlur={e => e.target.style.borderColor = '#d1d5db'}
                      />
                    </div>

                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#374151',
                        marginBottom: '8px',
                        marginTop: "0px",
                      }}>
                        To Date
                      </label>
                      <input
                        type="date"
                        value={tempEndDate}
                        onChange={(e) => setTempEndDate(e.target.value)}
                        max={new Date().toISOString().split('T')[0]}
                        min={tempStartDate}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '14px',
                          outline: 'none',
                          transition: 'border-color 0.2s',
                          boxSizing: 'border-box'
                        }}
                        onFocus={e => e.target.style.borderColor = '#b15dc6'}
                        onBlur={e => e.target.style.borderColor = '#d1d5db'}
                      />
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '12px'
                  }}>
                    <button
                      onClick={() => {
                        setShowCustomPopup(false);
                        setTempStartDate("");
                        setTempEndDate("");
                      }}
                      style={{
                        padding: '10px 20px',
                        background: 'transparent',
                        color: '#6B7280',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        minWidth: '80px'
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = '#f3f4f6';
                        e.currentTarget.style.borderColor = '#9ca3af';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.borderColor = '#d1d5db';
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        if (tempStartDate && tempEndDate) {
                          setCustomStartDate(tempStartDate);
                          setCustomEndDate(tempEndDate);
                          setDateFilterType('custom');
                          setShowCustomPopup(false);
                        }
                      }}
                      disabled={!tempStartDate || !tempEndDate}
                      style={{
                        padding: '10px 20px',
                        background: (!tempStartDate || !tempEndDate) ? '#9ca3af' : '#b15dc6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: (!tempStartDate || !tempEndDate) ? 'not-allowed' : 'pointer',
                        transition: 'background 0.2s',
                        minWidth: '80px'
                      }}
                      onMouseEnter={e => {
                        if (tempStartDate && tempEndDate) {
                          e.currentTarget.style.background = '#9d4edd';
                        }
                      }}
                      onMouseLeave={e => {
                        if (tempStartDate && tempEndDate) {
                          e.currentTarget.style.background = '#b15dc6';
                        }
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>

        {/* Income Summary Cards */}
        <div className="status-overview">
          {[
            { title: "Total Income", value: totals.totalIncome, color: "#2c6eaa" },
            { title: "Wallet Income", value: totals.walletIncome, color: "#4ecdc4" },
            { title: "Online Income", value: totals.onlineIncome, color: "#45b7d1" },
            { title: "Cash Income", value: totals.cashIncome, color: "#96ceb4" },
          ].map((card, idx) => (
            <div key={idx} style={{ background: card.color, color: "#fff", padding: "5px" }} className="status-card dine-in">
              <h4 style={{ display: 'flex', justifyContent: "center", fontSize: "16px", margin: "10px 0" }}>
                {card.title}
              </h4>
              <p style={{
                fontWeight: "bold",
                display: 'flex',
                justifyContent: "center",
                fontSize: "18px",
                margin: "10px 0"
              }}>
                ₹{card.value.toLocaleString("en-IN")}
              </p>
            </div>
          ))}
        </div>

        {/* Table Section */}
        < div className="payment-history-container" >
          <style>
            {`
.payment-history-container {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.filters {
  margin-bottom: 20px;
  width: 100%;
}

.filters-single-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  flex-wrap: nowrap;
  width: 100% !important;
}

.category-search {
  flex: 0 0 auto;
}

.category-search input {
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
  font-size: 14px;
  min-width: 200px;
  outline: none;
  transition: border-color 0.2s;
}

.category-search input:focus {
  border-color: #b15cd6;
  box-shadow: 0 0 0 2px rgba(177, 92, 214, 0.2);
}

.export-button {
  padding: 10px 20px;
  background-color: #b15cd6;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
  transition: background 0.2s;
}

.export-button:hover {
  background-color: #9d4edd;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E5E7EB;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #E5E7EB;
  padding: 12px 16px;
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
}

th {
  background-color: #b15dc6;
  font-weight: 600;
  font-size: 14px;
  color: white;
  position: sticky;
  top: 0;
}

tr:nth-child(even) {
  background-color: #fafafa;
}

tr:nth-child(odd) {
  background-color: #ffffff;
}

tr:hover {
  background-color: #f3f4f6;
}

@media screen and (max-width: 768px) {
  .payment-history-container {
    max-width: 100%;
    padding: 0px;
  }

  .filters-single-line {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .category-search {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .category-search input {
    width: 100%;
    max-width: 100%;
  }

  .export-button {
    width: 100%;
    max-width: 100%;
    align-self: center;
  }

  table {
    min-width: 600px;
  }
  
  .status-overview {
    flex-direction: column;
    gap: 12px;
  }
}

.my-container {
  overflow-y: scroll;
  -ms-overflow-style: none; 
  scrollbar-width: none;
}

.my-container::-webkit-scrollbar {
  display: none;
}

.tab-content {
  width: 100%;
  max-width: 1100px;
}
  @keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
  @media (min-width: 999px) {
    .export-button {
        margin-left: 0px !important;
        margin-top: 0px !important;
    }
}

/* Status colors */
.status-pending { color: #f59e0b; }
.status-completed { color: #10b981; }
.status-cancelled { color: #ef4444; }
.status-processing { color: #3b82f6; }
`}
          </style>
          {/* 
          <div className="filters"
            style={{
              overflow: "auto",
              scrollbarWidth: "none",
              overflowY: "hidden",
              marginBottom: "10px"
            }}>
            <div className="filters-single-line">
            
              <div className="category-search" style={{ display: "none" }}>
                <input
                  type="text"
                  placeholder="Search by category..."
                  value={selectedCategory === "All Categories" ? "" : selectedCategory}
                  onChange={(e) => {
                    const value = e.target.value.trim();
                    if (value === "") {
                      setSelectedCategory("All Categories");
                    } else {
                      setSelectedCategory(value);
                    }
                  }}
                  style={{
                    padding: "10px 14px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "14px",
                    minWidth: "200px",
                    outline: "none"
                  }}
                />
              </div>

              <button
                className="export-button"
                onClick={exportToCSV}
                style={{
                  padding: "10px 10px",
                  background: "#b15dc6",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "background 0.2s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#9d4edd"}
                onMouseLeave={e => e.currentTarget.style.background = "#b15dc6"}
              >
                Export to CSV
              </button>
            </div>
          </div> */}

          <div className="table-wrapper">
            <table style={{ marginTop: "0px" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>OrderID</th>
                  <th style={{ textAlign: "center" }}>Date & Time</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Payment</th>
                  <th style={{ textAlign: "center" }}>Transaction ID</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", padding: "40px" }}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '12px',
                        color: '#6B7280'
                      }}>
                        <div style={{ fontSize: '48px' }}>📊</div>
                        <h3 style={{ margin: 0, fontSize: '18px', color: '#374151' }}>
                          No orders found
                        </h3>
                        <p style={{ margin: 0, fontSize: '14px' }}>
                          {selectedDate || customStartDate || selectedCategory !== "All Categories"
                            ? `Try adjusting your filters`
                            : 'Start taking orders to see data here'}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }} >{item.orderId}</td>
                      <td style={{ textAlign: "center" }}>{new Date(item.orderDateAndTime).toLocaleString()}</td>
                      <td style={{ textAlign: "center" }}>{getUserName(item)}</td>
                      <td style={{ textAlign: "center" }}>{getPaymentMethod(item)}</td>
                      <td style={{ textAlign: "center" }}>{getTransactionId(item)}</td>
                      <td style={{ textAlign: "center" }}>
                        <span className={`status-${getOrderStatus(item).toLowerCase().replace(/\s+/g, '-')}`}>
                          {getOrderStatus(item)}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        ₹{Math.round(item.grandTotal || 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ),
    "Cash Billing": <Cashbilling />,
    Settlement: <Settlement />,
    WalletApproval: <WalletAdd />,
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="left-column">
            <div className="tabs-wrapperpayment" style={{ width:window.innerWidth<769 ? "94vw" : " " }}>
              <div style={{ textAlign: 'center' }}>
                {Object.keys(tabContent).map((label) => (
                  <button
                    key={label}
                    style={{
                      backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
                      border: 'none',
                      borderRadius: '10px',
                      width:window.innerWidth<769? "auto" :window.innerWidth < 1100 ? '110px' : 'auto',
                      height: '40px',
                      color: 'black',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      margin: window.innerWidth < 1100 ? '5px' : '10px',
                      fontSize: window.innerWidth < 1100 ? "0.8rem" : " ",
                    }}
                    className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>
                ))}
              </div>
              <div
                className="tab-content my-container"
                style={{
                  overflow: 'auto',
                  height: window.innerHeight <= 550 ? "60vh" : window.innerHeight <= 600 ? "65vh" : window.innerHeight > 600 ? "70vh" : containerHeight,
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  maxWidth: '1100px',
                  padding: '20px',
                  paddingTop: "5px",
                  display: window.innerWidth < 500 ? "90vw" : " ",
                }}
              >
                {tabContent[activeTab]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Management3;